import React, { createContext, useState, useEffect } from "react";
import { developAxios } from "../axios.config";

export const AllCourseContext = createContext();

function AllCourseContextProvider(props) {
	const [course, setCourse] = useState([]);
	const [id, setId] = useState([]);
	const [courseId, setCourseId] = useState(null);
	useEffect(() => {
		developAxios(localStorage.getItem("token"))
			.get("/getallCourse")
			.then(({ data }) => {
				setCourse(data.courses);
				setCourseId(data.courses[0]._id);
			})
			.catch((e) => {
				console.log(e);
			});
	}, []);

	return (
		<AllCourseContext.Provider
			value={{ course, setCourse, id, setId, courseId, setCourseId }}
		>
			{props.children}
		</AllCourseContext.Provider>
	);
}

export default AllCourseContextProvider;
